import { Link } from "react-router-dom";
import { ShieldOff } from "lucide-react";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="min-h-screen flex flex-col items-center justify-center bg-offwhite px-5 text-center">
      <ShieldOff className="text-deepblue mb-6" size={48} />
      <h1 className="font-heading font-extrabold text-4xl text-slate900 mb-3">404</h1>
      <p className="text-slate-600 mb-8">Page introuvable / Page not found</p>
      <Link to="/fr" data-testid="not-found-home-link" className="bg-coral text-white font-semibold px-6 py-3 rounded-full">
        Retour à l'accueil
      </Link>
    </div>
  );
}
